import type { ParticipantInitialDataType } from 'containers/Participants/Redux/Reducer/InitialStateType'

export const initialState: ParticipantInitialDataType = {
  loading: false,
  queries: {
    page: 1,
    per_page: 25,
  },
  participants: [],
  meta: {
    count: 0,
  },
  filterQuery: {
    sort: {
      login: 'desc',
    },
    search: '',
  },
  sortModel: [
    {
      field: 'login',
      sort: 'desc',
    },
  ],
  selectedParticipantIDs: [],
  // SelectAll object sets property for grid or page level selection of all participants.
  selectAll: {
    allVisible: false,
    all: false,
    page: 0,
  },
}
